import { render, staticRenderFns } from "./empower.vue?vue&type=template&id=1677d7f5&scoped=true&"
import script from "./empower.vue?vue&type=script&lang=js&"
export * from "./empower.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./empower.vue?vue&type=style&index=1&id=1677d7f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1677d7f5",
  null
  
)

export default component.exports